import {
  caseDetailDiff,
  type CaseDetailDiffContext,
  type CaseDetailDiffResult
} from '@codametrix/ui-common';
import {
  applyWorkerPublicPath,
  bootstrapWorkerPublicPathFromScriptLocation
} from './worker-public-path';

bootstrapWorkerPublicPathFromScriptLocation();

type WorkerRequest = {
  id: number;
  publicPath?: string;
  phase1: CMxAPI.Case;
  phase2: CMxAPI.Case;
  context?: CaseDetailDiffContext;
};

type WorkerResponse = {
  id: number;
  result?: CaseDetailDiffResult;
  error?: string;
};

self.onmessage = (event: MessageEvent<WorkerRequest>) => {
  const { id, publicPath, phase1, phase2, context } = event.data;

  if (publicPath) {
    applyWorkerPublicPath(publicPath);
  }

  try {
    const result = caseDetailDiff(phase1, phase2, context);
    const response: WorkerResponse = { id, result };
    self.postMessage(response);
  } catch (error) {
    const response: WorkerResponse = {
      id,
      error: error instanceof Error ? error.message : String(error)
    };
    self.postMessage(response);
  }
};

export {};
